import wrapPageElementWithStyles from './src/helpers/wrapPageElement'
export const wrapPageElement = wrapPageElementWithStyles

// IntersectionObserver polyfill for gatsby-image (Safari, IE)
if (typeof window.IntersectionObserver === 'undefined') {
  import('intersection-observer')
}

// Display a message when a service worker updates
// https://www.gatsbyjs.org/docs/add-offline-support-with-a-service-worker/#displaying-a-message-when-a-service-worker-updates
function createReloadToast() {
  const div = document.createElement('div')
  div.id = 'toast'
  div.classList.add('toast')
  div.innerHTML = `<button onClick="window.location.reload()">Updates are available. <span>Click to Reload</span>.</button>`
  document.body.append(div)
}

export const onServiceWorkerUpdateReady = () => {
  createReloadToast()
}
